import React, { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import MenuLanguagesComponent from "./MenuLanguagesComponent";
import { useTranslation } from "react-i18next";

export const LanguagesComponent = ({ controller, availableLanguages }) => {
  const [showLanguagesMenu, setShowLanguagesMenu] = useState(false);
  const { t } = useTranslation();

  const displayLanguagesMenu = () => {
    setShowLanguagesMenu(!showLanguagesMenu);
  };

  return (
    <div className={"languages"}>
      <OverlayTrigger
        delay={{ hide: 400, show: 120 }}
        placement="bottom"
        overlay={(props) => (
          <Tooltip {...props} className={showLanguagesMenu && "displayNoneTooltip"}>
            {t("catalogue.idioms")}
          </Tooltip>
        )}
      >
        <div onClick={displayLanguagesMenu} className={"LanguageMenuIconContainer"}>
          <ion-icon name="globe-outline" id={"LanguageMenuIcon"} />
        </div>
      </OverlayTrigger>
      {showLanguagesMenu && (
        <MenuLanguagesComponent
          handleShowLanguagesMenu={displayLanguagesMenu}
          controller={controller}
          availableLanguages={availableLanguages}
        />
      )}
    </div>
  );
};
